module.exports = __webpack_public_path__ + "img/Food Distribution.7207d306.jpg";